import "./style.scss";

interface IPriceBreakupSectionPSP {
  priceData: any;
  discountDescription: string;
  bookingData: any;
  tcsSlab: number;
}

const PriceBreakupSectionPSP: React.FC<IPriceBreakupSectionPSP> = ({ priceData, discountDescription = '', bookingData, tcsSlab = 0 }) => {

const handleTotalAmount = (strike?: boolean) => {
    if (strike) {
      return !!tcsSlab
        ? Number(
            (priceData?.total + (priceData?.total * (tcsSlab / 100))).toFixed()
          )
        : Number((priceData?.total).toFixed());
    } else {
      return !!tcsSlab
        ? Number(
            ((priceData?.total - priceData?.discount) + ((priceData?.total - priceData?.discount) * (tcsSlab / 100))).toFixed()
          )
        : Number((priceData?.total - priceData?.discount).toFixed());
    }
  };

  return (
    <div className="price-payment-card-wrapper-psp">
      <div className="price-details-header">
        <span>Price Details</span>
      </div>
      <div className="price-detail-row-wrapper">
        <div className="price-detail-row-wrapper-cabins">
          {!!priceData?.cabin_names?.length &&
            priceData?.cabin_names?.map((cabinName: string, index: number) => {
              return (
                <div key={index} className="common-row-wrapper">
                  <span className="cabin-fare-details">{cabinName}</span>
                  <span className="cabin-fare-details">{`₹ ${new Intl.NumberFormat("en-IN").format(
                    Number((priceData?.cabin_fares[index]).toFixed(2))
                  )}`}</span>
                </div>
              );
            })}
          {!!priceData?.service_tax_and_levies && (
            <div className="common-row-wrapper">
              <span className="service-tax-text">Service Tax & Levies</span>
              <span className="service-tax-amount">{`₹ ${new Intl.NumberFormat("en-IN").format(
                Number((priceData?.service_tax_and_levies).toFixed(2))
              )}`}</span>
            </div>
          )}
          {/* {!!priceData?.port_charges && (
            <div className="common-row-wrapper">
              <span className="port-text">(Port Charges + Gratuity)</span>
            </div>
          )} */}
          {!!priceData?.fuel_surcharge && (
            <div className="common-row-wrapper">
              <span className="service-tax-text">Fuel Surcharge</span>
              <span className="service-tax-amount">{`₹ ${new Intl.NumberFormat("en-IN").format(
                Number((priceData?.fuel_surcharge).toFixed(2))
              )}`}</span>
            </div>
          )}
          {!!priceData?.discount && (
            <div className="common-row-wrapper">
              <span className="discount-text">Discount</span>
              <span className="discount-amount">{`-₹ ${new Intl.NumberFormat("en-IN").format(
                Number((priceData?.discount).toFixed(2))
              )}`}</span>
            </div>
          )}
          {!!priceData?.discount && (
            <div className="common-row-wrapper">
              <span className="discount-title">({!!discountDescription ? discountDescription : Object.keys(priceData?.discount_category).join(", ")})</span>
            </div>
          )}
          {/* <div className="common-row-wrapper coupon-code-wrapper">
            <span className="applied-coupon-text">Applied Coupon</span>
            <div>
              <span className="applied-coupon-code">SUMMER 20</span>
              <span className="remove-text">Remove</span>
            </div>
          </div> */}
        </div>
        <div className="price-detail-row-wrapper-ssrs">
          {!!priceData?.ssr_names?.length && <span className="cabin-fare-details">Special Service Requests</span>}
          {!!priceData?.ssr_names?.length &&
            priceData?.ssr_names?.map((ssrName: string, index: number) => {
              return (
                <div key={index} className="common-row-wrapper">
                  <span className="ssr-fare-details">{ssrName?.toLowerCase()}</span>
                  <span className="ssr-fare-details">{`₹${new Intl.NumberFormat("en-IN").format(
                    Number((priceData?.ssr_fares[index]).toFixed(2))
                  )}`}</span>
                </div>
              );
            })}
          <div className="common-row-wrapper">
            <span className="gst-details">GST</span>
            <span className="gst-details">{`₹ ${new Intl.NumberFormat("en-IN").format(
              Number((priceData?.gst).toFixed(2))
            )}`}</span>
          </div>
          {!!tcsSlab && (
            <div className="common-row-wrapper">
              <span className="service-tax-details">
                TCS {tcsSlab}%
              </span>
              <span className="service-tax-details">{`₹ ${new Intl.NumberFormat(
                "en-IN"
              ).format(
                Number(
                  ((priceData?.total - priceData?.discount) * (tcsSlab / 100)).toFixed(2)
                )
              )}`}</span>
            </div>
          )}
        </div>
      </div>
      <div className="price-detail-row-wrapper-total border-top">
      <span className="total-amount-text">Total Amount</span>
      <div className="total-amount-price-wrapper">
        {!!priceData?.discount && (
          <div className="strikethrough-price-wrapper">
            <span className="striked-price">
              {`₹ ${new Intl.NumberFormat("en-IN").format(
                handleTotalAmount(true)
              )}`}
            </span>
            <div className="strike"></div>
          </div>
        )}
        <span className="total-amount-price">
          {bookingData?.status === "CONFIRMED" && (
            <span className="paid-text">Paid</span>
          )}
          {`₹ ${new Intl.NumberFormat("en-IN").format(handleTotalAmount())}`}
        </span>
      </div>
    </div>
      {bookingData?.status !== "CONFIRMED" && !!bookingData?.total && (
        <div className="booking-details-wrapper no-bb">
          <div>
            <span className="left-text-amount">Amount Paid</span>
            <span className="right-text-amount">
              {`₹ ${new Intl.NumberFormat("en-IN").format(Number(Number(bookingData?.amountPaid).toFixed()))}`}
            </span>
          </div>
          <div>
            <span className="left-text-amount">Pending Amount</span>
            <span className="right-text-amount">
              {`₹ ${new Intl.NumberFormat("en-IN").format(
                Number((Number(bookingData?.total) - Number(bookingData?.amountPaid)).toFixed())
              )}`}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PriceBreakupSectionPSP;
